import React, { useEffect, useRef, useState } from "react";
import { ReactComponent as DropDownIcon } from '../../assets/svg/drop_down.svg';
import { Button } from "../Shared/Buttons/Button";
import { FAQContent } from "./FAQContent";
import { FAQTexts } from "../../helpers/LayoutTexts";
import { useMediaQuery } from 'react-responsive';

interface Props {
    styles: any;   
}

export const FAQs: React.FC<Props> = (props) => {
    const styles = props.styles;
    const [activeCategoty, setActiveCategoty] = useState<number>(0);
    const [hasMoreTopics, setHasMoreTopics] = useState<boolean>(true);
    const tabsRef = useRef<HTMLDivElement>(null);
    const isMobile = useMediaQuery({ query: "(max-width: 786px)" });    
    const activeFAQ = FAQTexts.find((FAQ) => FAQ.categoryId === activeCategoty) || FAQTexts[0];

    useEffect(() => {
        if (!isMobile) {
            return;
        }
        updateMoreTopicsVisibility();
        window.addEventListener("resize", updateMoreTopicsVisibility);
        return () => {
            window.removeEventListener("resize", updateMoreTopicsVisibility);
        };
    }, [isMobile]);

    const handleCategoryClick = (categoryId: number) => {
        setActiveCategoty(categoryId);
    };

    const scrollTopics = () => {
        tabsRef.current?.scrollBy({
            left: tabsRef.current.clientWidth * 0.7,
            behavior: "smooth"
        });
    };

    const updateMoreTopicsVisibility = () => {
        const tabs = tabsRef.current;
        if (!tabs) {
            return;
        }
        setHasMoreTopics(tabs.scrollLeft + tabs.clientWidth < tabs.scrollWidth - 1);
    };
    
    return(
        <>
            <div style={styles.subTitle}> {isMobile ? "Select Topic" : "Topics"} </div>
            <div style={styles.wrapper}>
                {isMobile ? (
                    <>
                        <div style={styles.tabsWrapper}>
                            <div ref={tabsRef} style={styles.tabs} onScroll={updateMoreTopicsVisibility}>
                                {FAQTexts.map((FAQ) => (
                                    <Button 
                                        key={FAQ.categoryId}
                                        type="button" 
                                        style={{ 
                                            ...styles.tabButton, 
                                            ...(activeCategoty === FAQ.categoryId && styles.tabButton.active)
                                        }} 
                                        onClick={() => handleCategoryClick(FAQ.categoryId)}
                                        >
                                            {FAQ.categotyName} 
                                            <DropDownIcon 
                                                style={{
                                                    ...styles.categoryIcon,
                                                    ...(activeCategoty === FAQ.categoryId && styles.activeIcon)
                                                }}
                                            />
                                    </Button>
                                ))}
                            </div>
                            {hasMoreTopics && (
                                <button
                                    type="button"
                                    style={styles.moreTopicsButton}
                                    onClick={scrollTopics}
                                >
                                    &raquo;
                                </button>
                            )}
                        </div>
                        <div style={styles.contents}>
                            <FAQContent styles={styles.content} FAQs={activeFAQ.faqs} />
                        </div>
                    </>
                ) : (
                    <>
                        <div style={styles.tabs}>
                            {FAQTexts.map((FAQ) => (
                                <Button 
                                    key={FAQ.categoryId} 
                                    type="button" 
                                    style={{ 
                                        ...styles.tabButton, 
                                        ...(activeCategoty === FAQ.categoryId && styles.tabButton.active)
                                    }} 
                                    onClick={() => handleCategoryClick(FAQ.categoryId)}
                                >
                                    {FAQ.categotyName} 
                                    <DropDownIcon 
                                        style={{
                                            ...styles.categoryIcon,
                                            ...(activeCategoty === FAQ.categoryId && styles.activeIcon)
                                        }}
                                    />
                                </Button>
                            ))}
                        </div>
                        <div style={styles.contents}>
                            <FAQContent styles={styles.content} FAQs={FAQTexts[activeCategoty].faqs} />
                        </div>
                    </>
                )}
            </div>
        </>
    )
}